import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Drone
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTAgNyA3IiAvPgogIDxwYXRoIGQ9Im0xMCAxNC0zIDMiIC8+CiAgPHBhdGggZD0ibTE0IDEwIDMtMyIgLz4KICA8cGF0aCBkPSJtMTQgMTQgMyAzIiAvPgogIDxwYXRoIGQ9Ik0xNC4yMDUgNC4xMzlhNCA0IDAgMSAxIDUuNDM5IDUuODYzIiAvPgogIDxwYXRoIGQ9Ik0xOS42MzcgMTRhNCA0IDAgMSAxLTUuNDMyIDUuODY4IiAvPgogIDxwYXRoIGQ9Ik00LjM2NyAxMGE0IDQgMCAxIDEgNS40MzgtNS44NjIiIC8+CiAgPHBhdGggZD0iTTkuNzk1IDE5Ljg2MmE0IDQgMCAxIDEtNS40MjktNS44NzMiIC8+CiAgPHJlY3QgeD0iMTAiIHk9IjgiIHdpZHRoPSI0IiBoZWlnaHQ9IjgiIHJ4PSIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/drone
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Drone = createLucideIcon('drone', [
  ['path', { d: 'M10 10 7 7', key: 'zp14k7' }],
  ['path', { d: 'm10 14-3 3', key: '1jrpxk' }],
  ['path', { d: 'm14 10 3-3', key: '7tigam' }],
  ['path', { d: 'm14 14 3 3', key: 'vm23p3' }],
  ['path', { d: 'M14.205 4.139a4 4 0 1 1 5.439 5.863', key: '1tm5p2' }],
  ['path', { d: 'M19.637 14a4 4 0 1 1-5.432 5.868', key: '16egi2' }],
  ['path', { d: 'M4.367 10a4 4 0 1 1 5.438-5.862', key: '1wta6a' }],
  ['path', { d: 'M9.795 19.862a4 4 0 1 1-5.429-5.873', key: 'q39hpv' }],
  ['rect', { x: '10', y: '8', width: '4', height: '8', rx: '1', key: 'phrjt1' }],
]);

export default Drone;
